import React from "react";

export default class Editable extends React.Component {
  render() {
    // console.log('this.props.children', this.props.children)
    if (!this.props.editable) return this.props.children;
    let clone = React.cloneElement(this.props.children, {
      contentEditable: "true",
      suppressContentEditableWarning: true,
      onInput: (event) => {
        this.onInput(event);
      },
    });
    let children = clone.props.children;
    if (children && children[children.length - 1] === "") {
      children = [...children];
      children[children.length - 1] = "\xa0";
      clone = React.cloneElement(clone, {
        children,
      });
    }
    return clone;
  }
  onInput(event) {
    // Grabs the rendered text of the clicked element innerText respect CSS, if use raw DOM text use textContent
    let text = event.target.innerText;

    // reads the computed white-space value (normal, nowrap, pre, pre-wrap, pre-line, break-spaces,...)
    let whiteSpace = window.getComputedStyle(event.target)["white-space"] || "";

    if (!whiteSpace || !whiteSpace.startsWith("pre")) {
      // if (!whiteSpace.substr(0, "pre".length) === "pre") {
      // replace each single new line \n or non-breaking space \xA0 with a normal space
      text = text.replace(/[\n\xa0]/g, " ");
    } else {
      // collapse any spaces/tabs \s* around a newline to just the newline
      text = text.replace(/\s*\n\s*/g, "\n");
    }
    // Collapse runs of whitespace except newlines into a single space. \S = non-whitespace, [^\S] = whitespace, [^\S\n] = whitespace but NOT \n
    text = text.replace(/[^\S\n]+/g, " ");
    // trim whitespace at the start or end of the string
    text = text.replace(/^\s|\s$/g, "");
    console.log(JSON.stringify(text));
    if (this.props.onInput) {
      this.props.onInput(text);
    } else {
      // console.log('field', this.props.field)
      this.props.object[this.props.field] = text;
    }
  }
}
